export default __webpack_public_path__ + "static/media/profileMobile.be084a4e.svg";